import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
export function ApplyCTA() {
  return <div className="w-full pb-12 md:pb-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2136">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-2137">
        <div className="text-center" data-id="element-2138">
          <a href="https://www.fentonlakes.com/m6_edit_item.html" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-lg font-bold text-lg transition-all hover:opacity-90 hover:-translate-y-0.5 shadow-md hover:shadow-lg w-full md:w-auto" style={{
          backgroundColor: '#c8a84b',
          color: '#1a1a1a',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-2139">
            Click here to continue the membership application process
            <ExternalLinkIcon size={20} data-id="element-2140" />
          </a>
        </div>
      </div>
    </div>;
}